/**
 * Colors_T2.jsx
 * Identity for Template 2 (Blue Theme)
 */

// 1. Content Mapper for T2
export const mapTenantToLanding_T2 = (tenantData) => {
  return {
    companyId:       tenantData?.companyId,
    branchId:        tenantData?.branchId, 
    userId:          tenantData?.userId,
    logoUrl:         tenantData?.branding?.logoUrl      || '/assets/images/logo.png',
    companyName:     tenantData?.branding?.companyName  || 'Enterprise Travel Portal',
    brandName:       tenantData?.branding?.brandName    || 'Enterprise Portal',
    email:           tenantData?.branding?.email        || 'contact@enterprise.com',
    phones:          tenantData?.branding?.phones       || '9177656344',
    socials:         tenantData?.branding?.socials      || {},

    theme:           tenantData?.theme,
    themeColor1:     tenantData?.theme?.themeColor1,
    headerBgColor:   tenantData?.header?.bgColor,
    headerTextColor: tenantData?.header?.textColor,
    footerBgColor:   tenantData?.footer?.bgColor,
    footerTextColor: tenantData?.footer?.textColor,
    
    headerMenu:      Array.isArray(tenantData?.header) ? tenantData?.header : (tenantData?.header?.links || []),
    footerAboutText: tenantData?.footer?.aboutText || "Modern travel solutions for global teams.",
    footerCopyright: tenantData?.footer?.copyright || "© 2026 Enterprise SaaS. All Rights Reserved.",
    
    heroData:        tenantData?.hero,
    aboutUs:         tenantData?.aboutUs,
    contactUs:       tenantData?.contactUs,
  };
};

// 2. Color Resolver for T2 (Default Fallback: Corporate Blue)
export const getColors_T2 = (landingData) => {
  const headerBg = landingData?.headerBgColor || "#ffffff";

  return {
    // FALLBACK: #0052cc (A nice LinkedIn/Corporate Blue)
    theme1: landingData?.themeColor1 || "#112b54", 
    theme2: landingData?.footerBgColor || "#091e42", // Deep Dark Blue for footer
    theme3: headerBg,
    theme4: landingData?.theme?.themeColor4 || "#b38a3b", // Slate Blue for sidebar
    theme5: landingData?.theme?.themeColor5 || "#ffffff",

    headerText: landingData?.headerTextColor || (headerBg === "#ffffff" ? "#091e42" : "#ffffff"),
    footerText: landingData?.footerTextColor || "#ffffff",
  };
};